import { generateGruserObjectId } from '../helpers';
export const getCurrentGruserSlice = (state, gruser)=>{
    if (!gruser) {
        return {};
    }
    return state['@@gruser'].grusers[generateGruserObjectId(gruser)];
};
